import React, { Component } from 'react';
import { getFile } from '../../../../../../utils/modelData';
import styles from './index.less';
import img1 from '../../images/beijingtu_1.png';
import img2 from '../../images/beijingtu_2.png';

export default class IconModule extends Component {
  getImg = id => {
    return require(`../../images/icon/${id}.svg`);
  };

  getPic = (picurl, index) => {
    const file = picurl && picurl.split(',');
    let first = '';
    let second = '';
    if (file) {
      [first, second] = file;
    }

    if (index === 0) {
      return first;
    }
    return second;
  };

  render() {
    const { modules = [], picurl = '' } = this.props;
    return (
      <div className={styles.iconModule}>
        {modules[0] && modules[0].moduleName && (
          <div className="line-common">
            <div
              className="line-img"
              style={{ backgroundImage: `url(${this.getPic(picurl, 0) || img1})` }}
            />
            <div
              className="num-1 common"
              style={{
                backgroundColor: getFile(modules[0], 1) || '#D6D6D6',
                backgroundImage: `url(${getFile(modules[0], 0)})`,
              }}
            >
              {modules[0].showIconType === 0 && (
                <span>
                  <img src={this.getImg(getFile(modules[0], 0) || 'home')} alt="" />
                </span>
              )}

              <span>{modules[0].moduleName}</span>
            </div>
          </div>
        )}
        {modules[1] && modules[1].moduleName && (
          <div className="line-common">
            <div
              className="num-2 common"
              style={{
                backgroundColor: getFile(modules[1], 1) || '#D6D6D6',
                backgroundImage: `url(${getFile(modules[1], 0)})`,
              }}
            >
              {modules[1].showIconType === 0 && (
                <span>
                  <img src={this.getImg(getFile(modules[1], 0) || 'home')} alt="" />
                </span>
              )}
              <span>{modules[1].moduleName}</span>
            </div>
            <div
              className="line-img"
              style={{ backgroundImage: `url(${this.getPic(picurl, 1) || img2})` }}
            />
          </div>
        )}
        <div className="line-common">
          {modules[2] && modules[2].moduleName && (
            <div
              className="common common-box"
              style={{
                backgroundColor: getFile(modules[2], 1) || '#D6D6D6',
                backgroundImage: `url(${getFile(modules[2], 0)})`,
              }}
            >
              {modules[2].showIconType === 0 && (
                <span>
                  <img src={this.getImg(getFile(modules[2], 0) || 'home')} alt="" />
                </span>
              )}
              <span>{modules[2].moduleName}</span>
            </div>
          )}
          {modules[3] && modules[3].moduleName && (
            <div
              className="common common-box"
              style={{
                backgroundColor: getFile(modules[3], 1) || '#D6D6D6',
                backgroundImage: `url(${getFile(modules[3], 0)})`,
              }}
            >
              {modules[3].showIconType === 0 && (
                <span>
                  <img src={this.getImg(getFile(modules[3], 0) || 'home')} alt="" />
                </span>
              )}
              <span>{modules[3].moduleName}</span>
            </div>
          )}
          {modules[4] && modules[4].moduleName && (
            <div
              className="common common-box"
              style={{
                backgroundColor: getFile(modules[4], 1) || '#D6D6D6',
                backgroundImage: `url(${getFile(modules[4], 0)})`,
              }}
            >
              {modules[4].showIconType === 0 && (
                <span>
                  <img src={this.getImg(getFile(modules[4], 0) || 'home')} alt="" />
                </span>
              )}
              <span>{modules[4].moduleName}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}
